import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema } from "../primitives/ids.js";
import { ClientReviewStatusV1Schema } from "./approval-change.js";
import { StudioDepartureKitStatusV1Schema } from "./departure-kit-v1.js";
import { StudioProjectGenerationLockV1Schema, StudioRunRowV1Schema, } from "./studio-dashboard.js";
import { StudioIntakeSummaryV1Schema } from "./client-intake.js";
/** Simple workflow phase ids shared by Studio project room and portfolio list. */
export const StudioSimpleProjectPhaseIdSchema = z.enum([
    "waiting_for_client",
    "review_and_build",
    "generating",
    "preview_live",
    "client_approved",
    "packaging",
    "handoff_ready",
]);
export const StudioProjectLifecycleFlagsV1Schema = z
    .object({
    generating: z.boolean(),
    packaging: z.boolean(),
    handoffReady: z.boolean(),
    qaFailure: z.boolean(),
    staleGeneration: z.boolean(),
    generationLock: z.boolean(),
    hasPreview: z.boolean(),
    hasApproval: z.boolean(),
})
    .strict();
export const StudioProjectLifecyclePollHintsV1Schema = z
    .object({
    suggestedIntervalMs: z.number().int().positive(),
    reasons: z.array(z.string().min(1)),
})
    .strict();
export const StudioProjectLifecycleViewV1Schema = z
    .object({
    schemaId: z.literal("studio.projectLifecycleView.v1"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    generatedAt: z.string().datetime(),
    simplePhase: StudioSimpleProjectPhaseIdSchema,
    phaseLabel: z.string().min(1),
    phaseStatus: z.record(StudioSimpleProjectPhaseIdSchema, z.enum(["done", "current", "upcoming"])),
    primaryCta: z.string().min(1),
    primaryActionId: z.string().min(1),
    primaryDisabled: z.boolean(),
    nowTitle: z.string().min(1),
    nowCopy: z.string().min(1),
    flags: StudioProjectLifecycleFlagsV1Schema,
    exportRunId: z.string().nullable(),
    pollHints: StudioProjectLifecyclePollHintsV1Schema,
    latestRun: StudioRunRowV1Schema.optional(),
    clientReview: ClientReviewStatusV1Schema.optional(),
    departureKit: StudioDepartureKitStatusV1Schema.optional(),
    intakeSummary: StudioIntakeSummaryV1Schema.optional(),
    generationLock: StudioProjectGenerationLockV1Schema.optional(),
})
    .strict();
export const StudioProjectLifecycleSummaryV1Schema = z
    .object({
    schemaId: z.literal("studio.projectLifecycleSummary.v1"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    generatedAt: z.string().datetime(),
    simplePhase: StudioSimpleProjectPhaseIdSchema,
    phaseLabel: z.string().min(1),
    primaryActionId: z.string().min(1),
    primaryCta: z.string().min(1),
    flags: StudioProjectLifecycleFlagsV1Schema,
    exportRunId: z.string().nullable(),
    pollHints: StudioProjectLifecyclePollHintsV1Schema,
    lastRunUpdatedAt: z.string().datetime(),
    lastKnownRunStatus: z.string().min(1),
    currentBusinessGraphRevisionId: z.string().nullable(),
    generationLock: StudioProjectGenerationLockV1Schema.optional(),
    businessName: z.string().nullable().optional(),
    ownerLabel: z.string().min(1).max(160).nullable().optional(),
})
    .strict();
//# sourceMappingURL=studio-project-lifecycle.js.map